import React from "react";
import { connect } from "react-redux";
import { resetHighlightedMenu } from "../actions/navigationMenuActions";
import NavbarItems from "./NavbarItems";

export const Navbar = ({ resetHighlightedMenu }) => {
  return (
    <nav
      className="nav hidden-sm-down"
      onMouseLeave={resetHighlightedMenu}
      onBlur={resetHighlightedMenu}
      aria-label="Main"
    >
      <ul className="nav-list">
        <NavbarItems />
      </ul>
    </nav>
  );
};

export default connect(null, { resetHighlightedMenu })(Navbar);
